module.exports = __webpack_public_path__ + "static/suzyAndFriendsPodcast-53fbf7edfa9ffde6e085a0c319084988.jpg";